import src from "./andre-drummond-hero-with-case-desktop.jpg";
export default { src: src, aspect: 1.875, width: 2880, height: 1536 };